// Ejar Contracts page — the office's register on the Ejar platform, and
// importing one of its contracts into AMER.
//
// The ids are the central key service's approval numbers, which
// `PermissionService::createAndGrantToOwners()` writes as each permission row's
// id — so these constants must stay equal to the ones
// `database/migrations/2026_09_09_000001_add_ejar_contract_import_permissions.php`
// produces, or the page renders for nobody.
//
// Deliberately NOT reusing `CONTRACTS_EJAR_SUBMIT` (315): that key means "push
// this office's contract up to Ejar", and importing pulls one down and mints a
// local rent contract from it. Sharing the key would have let everyone who can
// submit a contract also create contracts from the platform.

/** contracts.ejar.platform_index — read the register, and one contract's detail */
export const EJAR_PLATFORM_CONTRACTS_INDEX = 1585;

/** contracts.ejar.import — the mapping proposal, and the import itself */
export const EJAR_CONTRACTS_IMPORT = 1586;
